import { createI18n } from 'vue-i18n';

const coreLocales = import.meta.glob('@nova/core-locales/**/*.json', { eager: true });
const satelliteLocales = import.meta.glob('@satellite/locales/**/*.json', {
  eager: true
});
const locales = import.meta.glob('@/locales/**/*.json', { eager: true });

const i18n = createI18n({
  locale: 'en',
  messages: loadLocaleMessages()
});

function loadLocaleMessages() {
  const messages = {};

  const allLocales = [
    ...Object.entries(coreLocales).map(([path, mod]) => ({ path, mod, isCore: true })),
    ...Object.entries(satelliteLocales).map(([path, mod]) => ({ path, mod, isCore: false })),
    ...Object.entries(locales).map(([path, mod]) => ({ path, mod, isCore: false }))
  ];

  for (const { path, mod, isCore } of allLocales) {
    const matched = path.match(/\/locales\/([a-zA-Z-]+)\/([a-zA-Z-]+)\.json$/);
    if (matched) {
      const locale = matched[1]; // e.g., 'en'
      const namespace = matched[2]; // e.g., 'common', 'createAppointment'

      messages[locale] = messages[locale] || {};

      if (isCore) {
        messages[locale].core = messages[locale].core || {};
        messages[locale].core[namespace] = mod.default;
      } else {
        messages[locale][namespace] = mod.default;
      }
    } else {
      console.warn('Unmatched locale path:', path);
    }
  }

  // ✅ Alias `es` to `es-mx` if it's not defined explicitly
  if (messages['es-mx'] && !messages['es']) {
    messages['es'] = messages['es-mx'];
  }

  return messages;
}

export default i18n;
